module.exports = __webpack_public_path__ + "static/media/kiel.35da4af7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/kiel.jpg
// module id = 742
// module chunks = 0